var Actions;
(function (Actions) {
    Actions["GET_BUDGET_SUMMARY_LIST"] = "getBudgetSummaryList";
    Actions["GET_BUDGET_SUMMARY_LIST_ID_DESC"] = "getBudgetSummaryListIdDesc";
    Actions["CREATE_BUDGET_SUMMARY_LIST"] = "createBudgetSummaryList";
    Actions["UPDATE_BUDGET_SUMMARY_LIST"] = "updateBudgetSummaryList";
    Actions["GET_BUDGET_SUMMARY_LIST_FILTER"] = "getBudgetSummaryListFilter";
    Actions["GET_BUDGET_SUMMARY_DATA"] = "getBudgetSummaryData";
    Actions["UPDATE_SELECTED_BUDGET_SUMMARY_ID"] = "updateSelectedBudgetSummaryId";
    Actions["UPDATE_SELECTED_BUDGET_SUMMARY_DESC"] = "updateSelectedBudgetSummaryDesc";
    Actions["UPDATE_SELECTED_BUDGET_SUMMARY_VERSION"] = "updateSelectedBudgetSummaryVersion";
    Actions["UPDATE_SELECTED_BUDGET_SUMMARY_DATE_FROM"] = "updateSelectedBudgetSummaryDateFrom";
    Actions["UPDATE_SELECTED_BUDGET_SUMMARY_DATE_TO"] = "updateSelectedBudgetSummaryDateTo";
    Actions["UPDATE_BUDGET_SUMMARY_SIZE"] = "updateBudgetSummarySize";
    Actions["RESET_BUDGET_SUMMARY_FILTER"] = "resetBudgetSummaryFilter";
    Actions["DOWNLOAD_TEMPLATE_BUDGET_SUMMARY"] = "downloadTemplateBudgetSummary";
    Actions["DOWNLOAD_BUDGET_SUMMARY"] = "downloadBudgetSummary";
    Actions["GET_BUDGET_SUMMARY_TYPE"] = "getBudgetSummaryType";
    Actions["GET_BUDGET_SUMMARY_VERSION"] = "getBudgetSummaryVersion";
    // validate: ==============================================
    Actions["CREATE_VALIDATE_BUDGET_SUMMARY_LIST"] = "createValidateBudgetSummaryList";
    Actions["UPDATE_VALIDATE_BUDGET_SUMMARY_PAGE"] = "updateValidateBudgetSummaryPage";
    Actions["UPDATE_VALIDATE_BUDGET_SUMMARY_SIZE"] = "updateValidateBudgetSummarySize";
    Actions["DOWNLOAD_VALIDATE_BUDGET_SUMMARY"] = "downloadValidateBudgetSummary";
    // submit: ==============================================
    Actions["CREATE_SUBMIT_BUDGET_SUMMARY_LIST"] = "createSubmitBudgetSummaryList";
    // detail: ==============================================
    Actions["GET_BUDGET_SUMMARY_DETAIL"] = "getBudgetSummaryDetail";
    Actions["DOWNLOAD_BUDGET_SUMMARY_DETAIL"] = "downloadBudgetSummaryDetail";
    Actions["UPDATE_BUDGET_SUMMARY_DETAIL_SIZE"] = "updateBudgetSummaryDetailSize";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_BUDGET_SUMMARY_LOADING"] = "setBudgetSummaryLoading";
    Mutations["SET_BUDGET_SUMMARY_HANDLE_PAGE"] = "setBudgetSummaryHandlePage";
    Mutations["SET_BUDGET_SUMMARY_LIST"] = "setBudgetSummaryList";
    Mutations["SET_BUDGET_SUMMARY_LIST_ID"] = "setBudgetSummaryListId";
    Mutations["SET_BUDGET_SUMMARY_LIST_DESC"] = "setBudgetSummaryListDesc";
    Mutations["SET_BUDGET_SUMMARY_LIST_VERSION"] = "setBudgetSummaryListVersion";
    Mutations["SET_BUDGET_SUMMARY_LIST_DATE_FROM"] = "setBudgetSummaryListDateFrom";
    Mutations["SET_BUDGET_SUMMARY_LIST_DATE_TO"] = "setBudgetSummaryListDateTo";
    Mutations["SET_BUDGET_SUMMARY_PAGE"] = "setBudgetSummaryPage";
    Mutations["SET_BUDGET_SUMMARY_LOAD_PAGE"] = "setBudgetSummaryLoadPage";
    Mutations["SET_SELECTED_BUDGET_SUMMARY_ID"] = "setSelectedBudgetSummaryId";
    Mutations["SET_SELECTED_BUDGET_SUMMARY_DESC"] = "setSelectedBudgetSummaryDesc";
    Mutations["SET_SELECTED_BUDGET_SUMMARY_VERSION"] = "setSelectedBudgetSummaryVersion";
    Mutations["SET_SELECTED_BUDGET_SUMMARY_DATE_FROM"] = "setSelectedBudgetSummaryDateFrom";
    Mutations["SET_SELECTED_BUDGET_SUMMARY_DATE_TO"] = "setSelectedBudgetSummaryDateTo";
    Mutations["SET_BUDGET_SUMMARY_STATUS"] = "setBudgetSummaryStatus";
    Mutations["SET_BUDGET_SUMMARY_SIZE"] = "setBudgetSummarySize";
    Mutations["SET_BUDGET_SUMMARY_USE_FILTER"] = "setBudgetSummaryUseFilter";
    Mutations["SET_BUDGET_SUMMARY_TYPE"] = "setBudgetSummaryType";
    Mutations["SET_BUDGET_SUMMARY_VERSION"] = "setBudgetSummaryVersion";
    // validate: ==============================================
    Mutations["SET_BUDGET_SUMMARY_VALIDATE"] = "setBudgetSummaryValidate";
    Mutations["SET_BUDGET_SUMMARY_PAGE_VALIDATE"] = "setBudgetSummaryPageValidate";
    Mutations["SET_BUDGET_SUMMARY_LOAD_PAGE_VALIDATE"] = "setBudgetSummaryLoadPageValidate";
    Mutations["SET_BUDGET_SUMMARY_HANDLE_PAGE_VALIDATE"] = "setBudgetSummaryHandlePageValidate";
    Mutations["SET_BUDGET_SUMMARY_HANDLE_SIZE_VALIDATE"] = "setBudgetSummaryHandleSizeValidate";
    // detail: ==============================================
    Mutations["SET_BUDGET_SUMMARY_DETAIL"] = "setBudgetSummaryDetail";
    Mutations["SET_BUDGET_SUMMARY_PAGE_DETAIL"] = "setBudgetSummaryPageDetail";
    Mutations["SET_BUDGET_SUMMARY_LOAD_PAGE_DETAIL"] = "setBudgetSummaryLoadPageDetail";
    Mutations["SET_BUDGET_SUMMARY_HANDLE_PAGE_DETAIL"] = "setBudgetSummaryHandlePageDetail";
    Mutations["SET_BUDGET_SUMMARY_DETAIL_SIZE"] = "setBudgetSummaryDetailSize";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
